import {
  QrCode,
  Image,
  Video,
  Music,
  FileText,
  User,
  MapPin,
  MessageSquare,
  Mail,
  Calendar,
  Share2,
  Wallet,
  Smartphone,
  Type,
  Scan,
  Database
} from 'lucide-react';
import { Tool } from './tools';

export const QR_LABS_TOOLS: Tool[] = [
  { id: '301', name: 'Image-to-QR Link Matrix', slug: '/qr/image-qr', description: 'Converts images to QR links.', category: 'Rich Media', icon: Image },
  { id: '302', name: 'Video-to-QR Stream Linker', slug: '/qr/video-qr', description: 'Generates video stream QR codes.', category: 'Rich Media', icon: Video },
  { id: '303', name: 'Audio & Podcast QR Engine', slug: '/qr/audio-qr', description: 'Encodes audio track links.', category: 'Rich Media', icon: Music },
  { id: '304', name: 'PDF Document QR Publisher', slug: '/qr/pdf-qr', description: 'Converts documents to QR.', category: 'Rich Media', icon: FileText },
  { id: '305', name: 'Digital Business Card (vCard) QR Studio', slug: '/qr/vcard-qr', description: 'Compiles contact details to QR.', category: 'Contactless', icon: User },
  { id: '306', name: 'Location Mapping & Coordinates QR', slug: '/qr/loc-qr', description: 'Encodes GPS coordinates to QR.', category: 'Contactless', icon: MapPin },
  { id: '307', name: 'SMS & Automated Text QR', slug: '/qr/sms-qr', description: 'Sets up a target phone number and text.', category: 'Contactless', icon: MessageSquare },
  { id: '308', name: 'Email Campaign Dispatch QR', slug: '/qr/email-qr', description: 'Prefills an email destination, subject, and body.', category: 'Contactless', icon: Mail },
  { id: '309', name: 'Event & Calendar RSVP QR', slug: '/qr/event-qr', description: 'Encodes event title, dates, and location.', category: 'Contactless', icon: Calendar },
  { id: '310', name: 'Multi-Link Social Bio QR Canvas', slug: '/qr/social-qr', description: 'Points to landing page or bio tree.', category: 'Social & Crypto', icon: Share2 },
  { id: '311', name: 'Crypto Wallet Address QR', slug: '/qr/crypto-qr', description: 'Encodes public crypto keys.', category: 'Social & Crypto', icon: Wallet },
  { id: '312', name: 'App Store Deep-Link QR', slug: '/qr/app-qr', description: 'Router QR code for iOS/Android.', category: 'Social & Crypto', icon: Smartphone },
  { id: '313', name: 'Dynamic Text Message Showcase QR', slug: '/qr/text-qr', description: 'Renders formatted text in a popup.', category: 'Social & Crypto', icon: Type },
  { id: '314', name: 'QR Code Scanner & Decoder Framework', slug: '/qr/scan-qr', description: 'Scans and decodes QR codes.', category: 'Social & Crypto', icon: Scan },
  { id: '315', name: 'Bulk QR Code Batch Exporter', slug: '/qr/bulk-qr', description: 'Exports bulk QR codes from CSV.', category: 'Social & Crypto', icon: Database },
];
